import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { FbmOrderProductDialogComponent } from 'src/app/components/fbm-order-product-dialog/fbm-order-product-dialog.component';
import { FbmOrdersService } from 'src/app/modules/fbm-orders/fbm-orders.service';

@Component({
  selector: 'app-fbm-order-cell-renderer',
  templateUrl: './fbm-order-cell-renderer.component.html',
  styleUrls: ['./fbm-order-cell-renderer.component.scss']
})
export class FbmOrderCellRendererComponent implements OnInit,OnDestroy {

  params: ICellRendererParams;
  public maxSize: number = 3;
  noImage:string ='assets/images/No_image.png';
  dialogRef:any;
  private destroy$ = new Subject<void>();

  constructor(private dialog:MatDialog,
    private fbmOrderService:FbmOrdersService) { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }
  
  viewSingleProduct(event:any,data:any):void{
   const target = event.target as any;
    const targetPosision = target.getBoundingClientRect();
    this.dialogRef = this.dialog.open(FbmOrderProductDialogComponent, {
      hasBackdrop: false,
      position: {
        left: targetPosision.right + 10 + "px",
        top: targetPosision.top - 30 + "px",
      },
      width: "460px",
      data:[data]
    });
  }

  viewAllProducts(event:any, data:any): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.target as any;
    const targetPosision = target.getBoundingClientRect();
    this.dialogRef = this.dialog.open(FbmOrderProductDialogComponent, {
      position: {
        left: targetPosision.right -145 + "px",
        top: targetPosision.top +25 + "px",
      },
      width: '460px',
      data: data, 
      backdropClass: ["cdk-overlay-transparent-backdrop"],
    });
    this.fbmOrderService.displayedProductModal.next(this.params.node);
  }

  closeDialog(e:any) {
    this.dialogRef.close();
    this.fbmOrderService.displayedProductModal.next(null);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
